<template>
  <div
    class="container-fluid mycontainer-fluid content"
    v-if="$parent.rerender"
  >
    <HelpFiledStep2
      text="2. Полное наименование проекта"
      :helpText="this.project.UF_HELP.FIELDS.STEP2['UF_NAME']"
    />
    <uf_name />

    <HelpFiledStep2
      text="3. Программа финансовой поддержки"
      :helpText="this.project.UF_HELP.FIELDS.STEP2['UF_SUPPORT_PROG_ID']"
    />
    <uf_support_prog_id />
    <uf_region_id />

    <template v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">
      <div class="content-title content-mb-14">
        4. Направление финансирования
      </div>
      <uf_direction_financing_id></uf_direction_financing_id>
    </template>

    <div class="content-title content-mb-14">
      <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">5</span><span v-else>4</span>. В структуре владения уставным капиталом преобладающее
      участие имеет паевой инвестиционный фонд
    </div>
    <uf_is_prevails_mutual_invest_fund></uf_is_prevails_mutual_invest_fund>

    <div class="content-title content-mb-14">
      <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">6</span><span v-else>5</span>. Требуемый объем финансирования со стороны Фонда, тыс. руб.
    </div>
    <uf_sum_request></uf_sum_request>

    <div class="content-title content-mb-14"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">7</span><span v-else>6</span>. Сроки займа, мес.</div>
    <uf_month_return></uf_month_return>

    <div class="content-title content-mb-14"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">8</span><span v-else>7</span>. Отрасль промышленности</div>
    <uf_industry_id></uf_industry_id>

    <div class="content-title content-mb-14"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">9</span><span v-else>8</span>. Подотрасль промышленности</div>
    <uf_sub_industry_id></uf_sub_industry_id>
    <template v-if="$parent.project.UF_SETTING && $parent.project.UF_SETTING.IS_VIEW_NEW_INFORMATION_PROJECT">
      <div class="content-title content-mb-14">
        <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">10</span><span v-else>9</span>. Информация о продукции проекта
        <VDropdown
          tag="span"
          trigger="click"
          placement="bottom"
          popperClass="custom-popper"
          style="display: inline"
        >
          <a class="icon-help icon-help-l40" />
          <template #popper>
            <div class="custom-popper-content">
              Продукты проекта, перечисленные в резюме должны быть синхронизированы с перечнем из финансовой модели
            </div>
          </template>
        </VDropdown>
      </div>
      <ProjectOkpdProducts></ProjectOkpdProducts>
    </template>
    <template v-else>
      <div class="content-title content-mb-14">
        <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">10</span><span v-else>9</span>. Информация о продукции (в соответствии с перечнем ОКПД)
      </div>
      <okpd></okpd>
    </template>

    <!-- <div class="content-title content-mb-14">
      9. Если продукция вашего проекта является высокотехнологичной и включена в приказ Минпромторга России от 16.09.2020 N 3092 или 02.07.2020 № 2095, укажите наименование продукции:
    </div>
    <HighTechList></HighTechList>-->

    <template v-if="project.UF_SETTING.IS_VIEW_CONFIRMATION_PART_FEDERAL_PROJECT == 1">
      <div class="content-title content-mb-14">
        <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">11</span><span v-else>10</span>. Подтверждение участия в Федеральном проекте "Производительность труда"<template v-if="isRobotizationDirection">/ Федеральном проекте "Развитие промышленной робототехники и автоматизации производства"</template>
      </div>
      <ConfirmFederalProject></ConfirmFederalProject>
    </template>
    <template v-else>
      <div class="content-title content-mb-14">
        <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">11</span><span v-else>10</span>. Подтверждение участия в Национальном проекте "Производительность
        труда"
      </div>
      <ConfirmNationalProject />
    </template>

    <div class="content-title content-mb-14"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">12</span><span v-else>11</span>. Аннотация проекта</div>
    <uf_annotation></uf_annotation>
    <div class="content-title content-mb-14">
      <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">13</span><span v-else>12</span>. Имеющийся результат по проекту
    </div>
    <uf_available_results></uf_available_results>
    <div class="content-title content-mb-14"><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">14</span><span v-else>13</span>. Место реализации проекта</div>
    <place></place>

    <div class="content-title content-mb-14">
      <span style="float:left;"
      ><span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">15</span><span v-else>14</span>. Продукция производится на спецтерритории</span
      >
      <span style="float: left;margin-top: 12px;margin-left: 10px;">
        <label class="switch">
          <input type="checkbox" v-model="project.UF_IS_PRODACTION_SP_TERR" />
          <span class="slider round"></span>
        </label>
      </span>
    </div>
    <SpecialPlace v-if="project.UF_IS_PRODACTION_SP_TERR"></SpecialPlace>

    <HelpFiledStep2
      :text="
      `${
        $parent.project.UF_DIRECTION_FINANCING_ID > 0? 16: 15
       }. Ключевые исполнители (поставщик продукции, услуг, на которого
      приходится не менее 20% от суммы займа)`"
      :helpText="this.project.UF_HELP.FIELDS.STEP2['BLOCK_COAUTHOR']"
    />
    <subcontractors />

    <div>
      <div class="content-title content-mb-14">
        <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">17</span><span v-else>16</span>. Продукция, комплектующим изделием которой является продукт проекта (в соотв. с приложением к ПП РФ от 17.07.2015 №719)
      </div>
      <PromProducts></PromProducts>
    </div>

    <div class="content-title content-mb-14">
      <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">18</span><span v-else>17</span>. Включение продукции проекта в Перечни критической продукции / отраслевые планы импортозамещения
    </div>
    <import_plan>tree_group_med_oborudovanie</import_plan>

    <template v-if="project.UF_SETTING.IS_VIEW_HIGH_TECH == 1">
      <div class="content-title content-title-2line content-mb-14">
        <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">19</span><span v-else>18</span> Продукция Проекта относится к высокотехнологичной
      </div>
      <HighTechProducts></HighTechProducts>
    </template>

    <div
      class="content-title content-title-2line content-mb-14"
      v-if="project.UF_SETTING.IS_HIDE_PRODUCTION_MARKET_WORK != 1"
    >
      <span v-if="project.UF_SETTING.IS_VIEW_HIGH_TECH == 1">
         <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">20</span><span v-else>19</span>.
      </span>
      <span v-else> <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">18</span><span v-else>17</span>.</span> Наличие рынка для продукции проекта и положительная динамика его развития
      <!--   начало блока подсказки   -->
      <span
        v-if="
          project.UF_HELP &&
            project.UF_HELP.FIELDS &&
            project.UF_HELP.FIELDS.STEP2 &&
            project.UF_HELP.FIELDS.STEP2.UF_IS_AVAILABILITY_MARKET
        "
        class="h-t-status-info info-holder-container"
      >
        <span class="info-holder-icon"></span>
        <span class="info-holder-content info-holder-content_link">
          <span class="info-holder-content__text">
            {{ project.UF_HELP.FIELDS.STEP2.UF_IS_AVAILABILITY_MARKET }}
          </span>
        </span>
      </span>
      <!--   конец блока подсказки   -->
      <Uf_is_availability_market></Uf_is_availability_market>
    </div>

    <div class="content-title content-title-2line content-mb-14">
      <span
        v-if="
          project.UF_SETTING.IS_HIDE_PRODUCTION_MARKET_WORK == 1 &&
            project.UF_SETTING.IS_VIEW_HIGH_TECH == 1
        "
      > <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">20</span><span v-else>19</span>.</span
      >
      <span
        v-else-if="
          project.UF_SETTING.IS_HIDE_PRODUCTION_MARKET_WORK == 1 &&
            project.UF_SETTING.IS_VIEW_HIGH_TECH != 1
        "
      > <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">19</span><span v-else>18</span>.</span
      >
      <span v-else> <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">21</span><span v-else>20</span>.</span>
      Продукция включена в Перечень критических комплектующих изделий,
      утверждаемых МВК
    </div>
    <criticalCompMVK></criticalCompMVK>

    <template
      v-if="project.UF_SETTING.IS_VIEW_REESTR_USING_RM == 1"
    >
      <div class="content-title content-title-2line content-mb-14">
        <span
          v-if="project.UF_SETTING.IS_VIEW_HIGH_TECH != 1"
        > <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">20</span><span v-else>19</span></span
        >
        <span v-else> <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">21</span><span v-else>20</span></span>. Компания включена в Реестр производителей товаров с использованием вторичного сырья?
      </div>
      <Uf_is_reestr_using_rm></Uf_is_reestr_using_rm>
    </template>

    <template v-if="project.UF_SETTING.IS_VIEW_OKPO_COMPANY == 1">
      <uf_okpo>
        <span
          v-if="
            project.UF_SETTING.IS_HIDE_PRODUCTION_MARKET_WORK == 1 &&
              project.UF_SETTING.IS_VIEW_HIGH_TECH == 1 &&
              project.UF_SETTING.IS_VIEW_REESTR_USING_RM == 1
          "
        > <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">22</span><span v-else>21</span>.</span
        >
        <span
          v-else-if="
            project.UF_SETTING.IS_HIDE_PRODUCTION_MARKET_WORK == 1 &&
              project.UF_SETTING.IS_VIEW_HIGH_TECH != 1
          "
        > <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">21</span><span v-else>20</span>.</span
        >
        <span v-else> <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">21</span><span v-else>20</span>.</span>
      </uf_okpo>
    </template>
    <template v-if="project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS == 1">
      <div class="content-title content-mb-14">
        <span
          v-if="
            project.UF_SETTING.IS_HIDE_PRODUCTION_MARKET_WORK == 1 &&
              project.UF_SETTING.IS_VIEW_HIGH_TECH == 1 &&
              project.UF_SETTING.IS_VIEW_REESTR_USING_RM == 1
          "
        > <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">{{ 22 + okpoShift }}</span><span v-else>{{ 21 + okpoShift }}</span>.</span
        >
        <span
          v-else-if="
            project.UF_SETTING.IS_HIDE_PRODUCTION_MARKET_WORK == 1 &&
              project.UF_SETTING.IS_VIEW_HIGH_TECH != 1
          "
        > <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">{{ 21 + okpoShift }}</span><span v-else>{{ 20 + okpoShift }}</span>.</span
        >
        <span v-else> <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">{{ 21 + okpoShift }}</span><span v-else>{{ 20 + okpoShift }}</span>.</span> Финансовые показатели организации
      </div>
      <financialIndicator></financialIndicator>
      <dividendsIndicator :isMainPunct="false"></dividendsIndicator>
    </template>

    <div v-if="countriesLoaded && project.UF_INDICATOR_VERSION === 1">
      <div class="content-title content-mb-14">
        <span v-if="$parent.project.UF_DIRECTION_FINANCING_ID > 0">22</span><span v-else>21</span>. Сбыт продукции проекта, обеспечивающий выход на целевой объем продаж
      </div>
      <export_countries></export_countries>

      <div
        class="row myrow content-mb-42"
        v-if="project.UF_INDICATOR_VERSION === 1"
      >
        <div class="col-xs-12 mycol">
          <textarea
            v-model="project.UF_SALE"
            :disabled="$parent.projectDisabled"
            class="i-main-style t-dop-style i-wid-50"
            placeholder="Укажите планируемые объемы продаж/спроса, наличие инструментов реализации продукции проекта, перечень договоренностей по реализации продукции проекта: соглашения, предварительные соглашения, переговоры и т.п."
          ></textarea>
        </div>
      </div>
    </div>
  </div>
  <!--container-fluid-->
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_DIRECTORIES, FETCH_DIRECTORY } from "@/store/actions.type";
import VueTagsInput from "@johmun/vue-tags-input";
import { AUTH_URL } from "@/common/config";
import Vue from "vue";
import SystemIntegrator from "@/components/project/form/partial/SystemIntegrator";
import Digital_solution from "@/components/project/form/partial/DigitalSolution";
import System_equipment from "@/components/project/form/partial/SystemEquipment";
import Uf_name from "@/components/project/form/partial/uf_name";
import Uf_support_prog_id from "@/components/project/form/partial/uf_support_prog_id";
import Uf_sum_request from "@/components/project/form/partial/uf_sum_request";
import Uf_month_return from "@/components/project/form/partial/uf_month_return";
import Uf_industry_id from "@/components/project/form/partial/uf_industry_id";
import Uf_sub_industry_id from "@/components/project/form/partial/uf_sub_industry_id";
import Okpd from "@/components/project/form/partial/okpd";
import ProjectOkpdProducts from "@/components/project/form/partial/ProjectOkpdProducts";
import Uf_annotation from "@/components/project/form/partial/uf_annotation";
import Uf_available_results from "@/components/project/form/partial/uf_available_results";
import Place from "@/components/project/form/partial/place";
import Subcontractors from "@/components/project/form/partial/subcontractors";
import Import_plan from "@/components/project/form/partial/import_plan";
import Uf_result_natural from "@/components/project/form/partial/uf_result_natural";
import Target_years from "@/components/project/form/partial/target_years";
import Export_countries from "@/components/project/form/partial/export_countries";
import Uf_is_reg_fond_help from "@/components/project/form/partial/uf_is_reg_fond_help";
import Uf_base_year from "@/components/project/form/partial/uf_base_year";
import HighTechList from "@/components/project/form/partial/HighTechList";
import Uf_region_id from "@/components/project/form/partial/uf_region_id";
import SpecialPlace from "@/components/project/form/partial/SpecialPlace";
import PromProducts from "@/components/project/form/partial/PromProducts";
import ConfirmNationalProject from "@/components/project/form/partial/ConfirmNationalProject";
import Uf_is_availability_market from "@/components/project/form/partial/uf_is_availability_market";
import criticalCompMVK from "@/components/project/form/partial/CriticalCompMVK";
import HighTechProducts from "@/components/project/form/partial/HighTechProducts";
import financialIndicator from "@/components/project/form/partial/FinancialIndicator";
import HelpFiledStep2 from "@/components/project/form/subpartial/HelpFiledStep2.vue";
import Uf_okpo from "@/components/project/form/partial/uf_okpo";
import { Dropdown as VDropdown } from "floating-vue";
import uf_is_prevails_mutual_invest_fund from "@/components/project/form/partial/uf_is_prevails_mutual_invest_fund";
import Uf_is_reestr_using_rm from "@/components/project/form/partial/uf_is_reestr_using_rm.vue";
import ConfirmFederalProject from "@/components/project/form/partial/ConfirmFederalProject.vue";
import dividendsIndicator from "@/components/project/form/partial/DividendsIndicator.vue";
import Uf_direction_financing_id from "@/components/project/form/partial/uf_direction_financing_id.vue";


export default {
  name: "step2",
  props: ["step", "project"],
  components: {
    Uf_okpo,
    VDropdown,
    Uf_direction_financing_id,
    dividendsIndicator,
    ConfirmFederalProject,
    Uf_is_reestr_using_rm,
    SpecialPlace,
    Uf_region_id,
    HighTechList,
    Uf_is_reg_fond_help,
    Export_countries,
    PromProducts,
    Target_years,
    Uf_result_natural,
    Import_plan,
    Subcontractors,
    Place,
    Uf_available_results,
    Uf_annotation,
    Okpd,
    ProjectOkpdProducts,
    Uf_sub_industry_id,
    Uf_industry_id,
    Uf_month_return,
    Uf_sum_request,
    Uf_support_prog_id,
    Uf_name,
    System_equipment,
    Digital_solution,
    SystemIntegrator,
    Uf_base_year,
    Uf_is_availability_market,
    criticalCompMVK,
    financialIndicator,
    VueTagsInput,
    HighTechProducts,
    uf_is_prevails_mutual_invest_fund,
    HelpFiledStep2,
    ConfirmNationalProject
  },
  data() {
    return {
      selectedTags: [],
      hCoExecutorTooltip:
        "Заполнение данного поля позволит Вам ускорить процедуру проведения акцептов платежей после получения средств займа.",
      h14tooltipShow: false,
      h14tooltip:
        "<img src='https://lkbe.frprf.ru/images/project/p13_info.png' />",
      siteUrl: "",
      tag: "",
      tags: [],
      RESULT_INTELLECTUAL_ACTIVITY: false,
      countriesLoaded: false,
      h18tooltip:
        "Ставка по предоставляемому целевому займу может быть изменена Фондом на 1% годовых,  если  выполнено требование п.7.3 Стандарта \"Цифровизация промышленности\"",
      h15tooltip:
        "Для возможного применения ставки 1 (один) процент годовых к займам, финансируемым по\n" +
        "                                программе «Цифровизация промышленности», Системный интегратор цифровых и\n" +
        "                                технологических\n" +
        "                                решений (далее - Системный интегратор), привлеченный в качестве Ключевого\n" +
        "                                исполнителя\n" +
        "                                (Одобренный ФРП при принятии решения о предоставлении займа) по проекту, должен\n" +
        "                                соответствовать следующим критериям:<br/>\n" +
        "                                1. являться резидентом РФ (определяется в соответствии с законодательством о валютном регулировании и валютном контроле);<br/>\n" +
        "                                2. не являться дочерним хозяйственным обществом (определяется в соответствии с ч. 1 ст. 67.3 ГК РФ) юридических лиц, созданных в соответствии с законодательством иностранных государств;<br/>\n" +
        "                                3. не находиться  процессе ликвидации или банкротства;<br/>\n" +
        "                                4. выплаты Заемщика по договорам/контрактам, заключенным с Системным интегратором в ходе реализации проекта составляют более 50% от суммы займа;<br/>\n" +
        "                                5. должен быть включен в один из рейтингов (применению подлежит актуальный рейтинг на последнюю отчетную дату и учитывается включение ключевого исполнителя в последнюю версию рейтинга российских ИТ-компаний), публикующихся на следующих информационных ресурсах:<br/>\n" +
        "                                • Раздел \"ИТ-консалтинг (разработка и системная интеграция)\" рэнкинга \"Список крупнейших российских консалтинговых групп и компаний\" Эксперт-РА (https://raex-a.ru/);<br/>\n" +
        "                                • Крупнейшие ИТ-компании России Cnews (www.cnews.ru);<br/>\n" +
        "                                • Крупнейшие ИТ-компании России Tadviser (www.tadviser.ru)."
    };
  },
  created() {
    this.siteUrl = AUTH_URL;

    this.$store.dispatch(FETCH_DIRECTORIES, [
      "program_fin_support",
      "tree/industry",
      "code_okpd",
      "regions",
      "sp_monogorod",
      "list_import_plan",
      "product_plan_import",
      "start_pokazatel",
      "reg_fond_list",
      "tree/vid_prom_products",
      "sp_confirmation_part_national_project",
      "tree/sp_orders_high_tech_industry",
      "sp_direction_financing"
    ]);

    if (this.project.SUBCONTRACTORS.length === 0) {
      //this.project.SUBCONTRACTORS.push({});
    }

    if (this.project.INDICATORS.items.length === 0) {
      this.project.INDICATORS.items = new Object();
    }
    let m = this;
    this.project.INDICATORS.INDICATORS_ID.forEach(function(indicator) {
      if (typeof m.project.INDICATORS.items[indicator] === "undefined") {
        Vue.set(m.project.INDICATORS.items, indicator, []);
      }
      for (
        let year = m.project.INDICATORS.yearStart;
        year <= m.project.INDICATORS.yearEnd;
        year++
      ) {
        let t = m.project.INDICATORS.items[indicator].filter(
          c => c.UF_INDICATORS_YEAR === year
        );
        if (t.length === 0) {
          m.project.INDICATORS.items[indicator].push({
            UF_INDICATORS_VALUE: 0,
            UF_INDICATORS_YEAR: year,
            UF_INDICATORS_ID: indicator
          });
        }
      }
    });

    this.$store.dispatch(FETCH_DIRECTORY, ["country"]).then(() => {
      this.project.UF_EXPORT_COUNTRY_ID.forEach(function(cId) {
        this.directory.country.forEach(function(c) {
          if (cId === c.ID) {
            this.selectedTags.push(c.NAME);
          }
        }, this);
      }, this);
      this.countriesLoaded = true;
    }, this);

    this.$store
      .dispatch(FETCH_DIRECTORY, ["tree/sp_infoproduction"])
      .then(() => {
      }, this);
  },
  methods: {
    onTagAdded(slug) {
      if (slug > 0) {
        this.project.UF_EXPORT_COUNTRY_ID.push(
          this.directory.country[parseInt(slug)].ID
        );
      }
    },
    onTagRemoved(slug) {
      let rem = 0;
      this.directory.country.forEach(function(c) {
        if (c.NAME === slug) {
          rem = c.ID;
        }
      });
      if (rem > 0) {
        this.project.UF_EXPORT_COUNTRY_ID.forEach(function(c, index) {
          if (rem === c) {
            this.project.UF_EXPORT_COUNTRY_ID.splice(index, 1);
          }
        }, this);
      }
    },
    getProgramCode(id) {
      let t = this.directory.program_fin_support.filter(c => c.ID === id);
      if (t.length > 0) {
        return t[0].CODE;
      }
      return "";
    },
    getInfoproductionId(code) {
      let t = this.directory.tree_sp_infoproduction.filter(
        c => c.CODE === code
      );
      if (t.length > 0 && t[0].URL !== null) {
        return t[0].ID;
      }
      return "";
    },
    programCode(id) {
      let els = this.directory.program_fin_support.filter(function(el) {
        if (el.ID === id) {
          return true;
        }
        return false;
      }, this);
      if (els.length > 0) {
        return els[0].CODE;
      }
      return "";
    }
  },
  computed: {
    okpoShift() {
      return this.project.UF_SETTING &&
        this.project.UF_SETTING.IS_VIEW_OKPO_COMPANY == 1
        ? 1
        : 0;
    },
    countries() {
      let els = this.directory.country.filter(function(el) {
        for (let i = 0; i < this.project.UF_EXPORT_COUNTRY_ID.length; i++) {
          if (el.ID === this.project.UF_EXPORT_COUNTRY_ID[i]) {
            return true;
          }
        }
        return false;
      }, this);
      return els;
    },
    countryTags() {
      let countries = {};
      this.directory.country.forEach(function(el, k) {
        countries[k] = el.NAME;
      }, this);
      return countries;
    },
    isRobotizationDirection() {
      let id = this.project.UF_DIRECTION_FINANCING_ID;
      if (!(id > 0)) return false;
      let dir = (this.directory.sp_direction_financing || []).find(function(
        item
      ) {
        return item.ID == id;
      });
      return !!dir && dir.CODE === "robotization_of_production";
    },
    ...mapGetters(["directory"])
  }
};
</script>

<style scoped></style>
